import React, { useState } from "react";
import { Box, Grid, Item } from "@mui/material";
import AllStocksContainer from "./StocksPageComponents/AllStocksContainer";
import PressReleasesContainer from "./StocksPageComponents/PressReleasesContainer";

export const StocksPage = ({ mode }) => {
  return (
    <Grid
      container
      sx={{
        gap: { md: "20px", sm: "10px" },
        color: "fontPrimaryColor.main",

        // borderTop: "1px solid rgb(230, 235, 241)",
      }}
      spacing={0}
      className="dashboard__stocks__page"
    >
      <Grid
        item
        xs={12}
        md={8.6}
        lg={8.3}
        xl={8.5}
        // bgcolor="#ffffff"
        sx={{ borderRadius: "8px", padding: { md: "5px 10px" } }}
      >
        {}
        <AllStocksContainer mode={mode} />
      </Grid>
      <Grid item xs={12} md={3} lg={3.2} xl={3}>
        <PressReleasesContainer />
      </Grid>
    </Grid>
  );
};
